import React from "react";
import { FaDigitalTachograph, FaUsersCog, FaCogs, FaCloud, FaNetworkWired, FaClock } from "react-icons/fa";

const capabilities = [
  {
    icon: <FaDigitalTachograph className="text-[#162357] text-4xl mb-4" />,
    title: "Digital transformation",
    description: "Digitize all manufacturing operations, integrate with ERP, automate data collection for real-time visibility and better decision-making."
  },
  {
    icon: <FaUsersCog className="text-[#0077CC] text-4xl mb-4" />,
    title: "Empower shop floor users",
    description: "Guide operators through the process, provide real-time control to improve reactivity and efficiency."
  },
  {
    icon: <FaCogs className="text-[#0096D6] text-4xl mb-4" />,
    title: "Improved operational performance",
    description: "Standardize business processes to prevent losses, reduce waste, improve quality."
  },
  {
    icon: <FaCloud className="text-[#005B9F] text-4xl mb-4" />,
    title: "24/7 resilience",
    description: "Provide 24/7 operational resilience, for 'always-on' operations, to multi-tenant Cloud ERP."
  },
  {
    icon: <FaNetworkWired className="text-[#003366] text-4xl mb-4" />,
    title: "Enterprise solution",
    description: "Multi-site roll-out enables Enterprise-wide visibility of performance with global reporting."
  },
  {
    icon: <FaClock className="text-[#1C8DD9] text-4xl mb-4" />,
    title: "Fast time-to-value",
    description: "Out-of-the-box solution, requiring close to zero customisation."
  },
];

const  InforCapabilities=() =>{
  return (
    <div className="bg-white py-12 px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl font-bold text-center text-[#100d0d] mb-10">Key Capabilities</h2>
      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {capabilities.map((capability, index) => (
          <div
            key={index}
            className="bg-[#F0F8FF] rounded-2xl shadow-md p-6 text-center hover:shadow-xl transition-shadow duration-300"
          >
            {capability.icon}
            <h3 className="text-xl font-semibold text-[#003366] mb-2">{capability.title}</h3>
            <p className="text-gray-700 text-sm">{capability.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
export default InforCapabilities;